// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(backgroundColorOpt, headingColorOpt, colorOpt, hyperlinkColorOpt, param) {
  var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme__Color$PrezzeeRibbon.lilac50;
  var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme__Color$PrezzeeRibbon.gray800;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.gray600;
  var hyperlinkColor = hyperlinkColorOpt !== undefined ? hyperlinkColorOpt : Theme__Color$PrezzeeRibbon.blue400;
  return {
          backgroundColor: backgroundColor,
          headingColor: headingColor,
          color: color,
          hyperlinkColor: hyperlinkColor
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
